import { memo } from 'react';
export function memoWithDisplayName(Component, displayName, propsAreEqual) {
  Component.displayName = displayName;
  return /*#__PURE__*/memo(Component, propsAreEqual);
}